import React from 'react';
import { connect } from 'react-redux';

@connect((store) => {
  return {
    files: store.files,
    loggedUser: store.loggedUser,
  };
})
class ManageAccess extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { dispatch, file, onSelect } = this.props;

    const handleSelect = () => {
      dispatch({ type: 'UPDATE_FILES_SELECTED', selected: file });
      dispatch({ type: 'UPDATE_FILES_ACTION_ITEM', action: 'accessInRow' });
      onSelect();
    };

    return (
      <a onClick={handleSelect}>
        Manage File Access
        <i className="material-icons">people_outline</i>
      </a>
    );
  }
}

export default ManageAccess;
